/* eslint-disable no-unused-vars */
import {
  AddLocationAltRounded,
  BarChartRounded,
  ConnectWithoutContactRounded,
  DirectionsBoatRounded,
  GroupRounded,
  HomeWorkRounded,
  Inventory2Outlined,
  NewspaperRounded,
  PermContactCalendarRounded,
  QrCodeRounded,
  ReceiptLongRounded,
  ReviewsRounded,
  StorefrontRounded,
  TravelExploreRounded,
  VpnLockRounded,
  WhereToVoteRounded
} from '@mui/icons-material';
import { Box, styled } from '@mui/material';

import { URL_ENDPOINT } from 'src/utils/constants/service';

export const MAX_TIMES_RETRY_GET_DATA = 5;

export enum TypeTabCompany {
  Overview = 'Overview',
  Addresses = 'Addresses',
  Contacts = 'Contacts',
  Reviews = 'Reviews',
  SocialMedia = 'Social Media',
  WebDetails = 'Web Details',
  NegativeMedia = 'Negative Media',
  Trademark = 'Trademarks',
  StockPlace = 'Stock / Share Prices',
  Alerts = 'Alerts',
  DataAnalytics = 'Trade Analytics',
  SupplyChainMap = 'Supply Chain Map',
  BillsOfLading = 'Bills of Lading',
  HSCode = 'HS Code',
  Customers = 'Customers',
  Suppliers = 'Suppliers',
  Competitors = 'Competitors',
  PortsOfDelivery = 'Port of Delivery ',
  PortsOfOrigin = 'Port of Origin',
  TradingArea = 'Trading Area',
}

export interface ICompanyTab extends ITabSetting {
  dataExistenceField?: string;
}

export const TABS_COMPANY: ICompanyTab[] = [
  {
    key: TypeTabCompany.Overview,
    label: TypeTabCompany.Overview,
    icon: HomeWorkRounded,
    disable: false,
  },
  {
    key: TypeTabCompany.Contacts,
    label: TypeTabCompany.Contacts,
    icon: PermContactCalendarRounded,
    disable: false,
    dataExistenceField: 'is_contact_exist',
    endpoints: [
      URL_ENDPOINT.company.companies + 'contacts/ai/{company_id}',
      URL_ENDPOINT.company.companies + 'contacts/{company_id}'
    ]
  },
  {
    key: TypeTabCompany.SocialMedia,
    label: TypeTabCompany.SocialMedia,
    icon: ConnectWithoutContactRounded,
    disable: false,
    dataExistenceField: 'is_social_media_exist',
    endpoints: [
      URL_ENDPOINT.company.companies + 'social-media/ai/{company_id}',
      URL_ENDPOINT.company.companies + 'social-media/{company_id}'
    ]
  },
  {
    key: TypeTabCompany.Addresses,
    label: TypeTabCompany.Addresses,
    icon: AddLocationAltRounded,
    disable: false,
    dataExistenceField: 'is_address_exist',
    endpoints: [
      URL_ENDPOINT.company.companies + 'get-lat-lng-by-company-id/{company_id}'
    ]
  },
  {
    key: TypeTabCompany.Reviews,
    label: TypeTabCompany.Reviews,
    icon: ReviewsRounded,
    disable: false,
    dataExistenceField: 'is_reviews_exist',
    endpoints: [
      URL_ENDPOINT.company.companies + 'review/{company_id}/reviews',
      URL_ENDPOINT.company.companies + 'review/{company_id}/detail',
      URL_ENDPOINT.company.companies + 'review/{company_id}/popular-questions',
      URL_ENDPOINT.company.companies + 'social-review/{company_id}'
    ]
  },
  {
    key: TypeTabCompany.WebDetails,
    label: TypeTabCompany.WebDetails,
    icon: TravelExploreRounded,
    disable: false,
    dataExistenceField: 'is_website_exist',
    endpoints: [
      URL_ENDPOINT.company.companies + 'list-web-detail/{company_id}'
    ]
  },
  {
    key: TypeTabCompany.NegativeMedia,
    label: TypeTabCompany.NegativeMedia,
    icon: NewspaperRounded,
    disable: false,
    dataExistenceField: 'is_negative_story_exist',
    endpoints: [
      URL_ENDPOINT.company.companies + 'negative-story-web/{company_id}',
      URL_ENDPOINT.company.companies + 'negative-exactly-story-web/{company_id}'
    ]
  },
  // {
  //   key: TypeTabCompany.Trademark,
  //   label: TypeTabCompany.Trademark,
  //   icon: StarRounded,
  //   disable: false,
  // },
  {
    key: TypeTabCompany.StockPlace,
    label: TypeTabCompany.StockPlace,
    icon: Inventory2Outlined,
    disable: false,
    dataExistenceField: 'is_stock_info_exist',
    endpoints: [
      URL_ENDPOINT.company.companies + 'market-price/{company_id}'
    ]
  },
  {
    key: TypeTabCompany.Alerts,
    label: TypeTabCompany.Alerts,
    icon: VpnLockRounded,
    disable: false,
    dataExistenceField: 'is_sanction_exist',
    endpoints: [
      URL_ENDPOINT.company.companies + 'sanction/{company_id}'
    ]
  },
  {
    key: TypeTabCompany.DataAnalytics,
    label: TypeTabCompany.DataAnalytics,
    icon: BarChartRounded,
    disable: false,
    dataExistenceField: 'has_analytics_tab',
    endpoints: [
      URL_ENDPOINT.companyTradeData.analytics.chart,
      URL_ENDPOINT.companyTradeData.analytics.list,
    ],
  },
  // {
  //   key: TypeTabCompany.SupplyChainMap,
  //   label: TypeTabCompany.SupplyChainMap,
  //   icon: AltRouteRounded,
  //   disable: false,
  // },
  {
    key: TypeTabCompany.BillsOfLading,
    label: TypeTabCompany.BillsOfLading,
    icon: ReceiptLongRounded,
    disable: false,
    dataExistenceField: 'has_bol_tab',
    endpoints: [
      URL_ENDPOINT.companyTradeData.transactions,
      URL_ENDPOINT.companyTradeData.transactionsPaymentStatus,
      URL_ENDPOINT.companyTradeData.transactionsCount,
    ],
  },
  {
    key: TypeTabCompany.HSCode,
    label: TypeTabCompany.HSCode,
    icon: QrCodeRounded,
    disable: false,
    dataExistenceField: 'has_hscode_tab',
    endpoints: [
      URL_ENDPOINT.companyTradeData.hsCode.chart,
      URL_ENDPOINT.companyTradeData.hsCode.list,
    ],
  },
  {
    key: TypeTabCompany.Customers,
    label: TypeTabCompany.Customers,
    icon: GroupRounded,
    disable: false,
    dataExistenceField: 'has_customer_tab',
    endpoints: [
      URL_ENDPOINT.companyTradeData.buyer.chart,
      URL_ENDPOINT.companyTradeData.buyer.list,
      URL_ENDPOINT.companyTradeData.buyer.map,
    ],
  },
  {
    key: TypeTabCompany.Suppliers,
    label: TypeTabCompany.Suppliers,
    icon: StorefrontRounded,
    disable: false,
    dataExistenceField: 'has_supplier_tab',
    endpoints: [
      URL_ENDPOINT.companyTradeData.supplier.chart,
      URL_ENDPOINT.companyTradeData.supplier.list,
      URL_ENDPOINT.companyTradeData.supplier.map,
    ],
  },
  // {
  //   key: TypeTabCompany.Competitors,
  //   label: TypeTabCompany.Competitors,
  //   icon: CompareRounded,
  //   disable: false,
  //   dataExistenceField: 'has_competitor_tab'
  // },
  {
    key: TypeTabCompany.PortsOfDelivery,
    label: TypeTabCompany.PortsOfDelivery,
    icon: DirectionsBoatRounded,
    disable: false,
    dataExistenceField: 'has_import_port_tab',
    endpoints: [
      URL_ENDPOINT.companyTradeData.pod.chart,
      URL_ENDPOINT.companyTradeData.pod.list,
      URL_ENDPOINT.companyTradeData.pod.map,
    ],
  },
  {
    key: TypeTabCompany.PortsOfOrigin,
    label: TypeTabCompany.PortsOfOrigin,
    icon: WhereToVoteRounded,
    disable: false,
    dataExistenceField: 'has_export_port_tab',
    endpoints: [
      URL_ENDPOINT.companyTradeData.poo.chart,
      URL_ENDPOINT.companyTradeData.poo.list,
      URL_ENDPOINT.companyTradeData.poo.map,
    ],
  },
  // {
  //   key: TypeTabCompany.TradingArea,
  //   label: TypeTabCompany.TradingArea,
  //   icon: ShareLocationRounded,
  //   disable: false,
  // },
];

// Common Style WhiteBox use in multiple  tab
export const StyledWhiteBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius * 2,
  background: theme.palette.background.default,
}));
